// -----------------------------------------------------------------------------
// Voce narrante del gioco (Fase 6) — Web Speech API (speechSynthesis), it-IT.
// Separata da VoiceOver: NON usa aria-live. Legge la frase naturale della prova
// fornita dal motore. Fallback silenzioso se l'API non è disponibile.
// Interfaccia allineata al golden master (speak / stopSpeaking).
// -----------------------------------------------------------------------------
let unlocked = false;
let cachedVoice = null;

function synth() {
  if (typeof window === "undefined") return null;
  return window.speechSynthesis || null;
}

export function speechAvailable() {
  return !!synth();
}

// Sceglie una voce italiana disponibile sul dispositivo (it-IT preferita).
function pickVoice() {
  const s = synth();
  if (!s) return null;
  let voices = [];
  try {
    voices = s.getVoices() || [];
  } catch {
    voices = [];
  }
  cachedVoice =
    voices.find((v) => v.lang && v.lang.toLowerCase() === "it-it") ||
    voices.find((v) => v.lang && v.lang.toLowerCase().startsWith("it")) ||
    null;
  return cachedVoice;
}

// Da chiamare DENTRO un gesto utente (tap): sblocca l'audio su Safari/iOS e
// registra il caricamento asincrono delle voci (onvoiceschanged).
export function primeSpeech() {
  const s = synth();
  if (!s) return;
  try {
    if ("onvoiceschanged" in s) {
      s.onvoiceschanged = () => pickVoice();
    }
    pickVoice();
    if (!unlocked) {
      const u = new SpeechSynthesisUtterance(" ");
      u.volume = 0;
      u.lang = "it-IT";
      s.speak(u); // colpo a vuoto per sbloccare l'audio
      unlocked = true;
    }
  } catch {
    // no-op: la voce è un miglioramento, mai un blocco
  }
}

export function speak(text, onEnd) {
  const s = synth();
  if (!s || !text) {
    if (typeof onEnd === "function") onEnd();
    return;
  }
  try {
    s.cancel(); // evita sovrapposizioni con l'annuncio precedente
    const u = new SpeechSynthesisUtterance(String(text));
    u.lang = "it-IT";
    u.rate = 1.0;
    u.pitch = 1.0;
    const v = cachedVoice || pickVoice();
    if (v) u.voice = v;
    if (typeof onEnd === "function") {
      u.onend = () => onEnd();
      u.onerror = () => onEnd(); // non bloccare mai il gioco se la voce fallisce
    }
    s.speak(u);
  } catch {
    if (typeof onEnd === "function") onEnd();
  }
}

export function stopSpeaking() {
  const s = synth();
  if (!s) return;
  try {
    s.cancel();
  } catch {
    // no-op
  }
}
